'use strict';
var window = require('window'),
    vendors = ['ms', 'moz', 'webkit', 'o'],
    i = vendors.length,
    _cancelRequestAnimationFrame = window.cancelAnimationFrame;

function getCafPolyfill() {
    var polyfill;

    while (--i > -1 && !polyfill) {
        polyfill = window[vendors[i] + 'CancelAnimationFrame'] || window[vendors[i] + 'CancelRequestAnimationFrame'];
    }

    if (!polyfill) {
        polyfill = clearTimeout;
    }

    return polyfill;
}

if (!_cancelRequestAnimationFrame) {
    _cancelRequestAnimationFrame = getCafPolyfill();
}

module.exports = _cancelRequestAnimationFrame;
